import { UserResponseDto } from '@headbox-ui/auth-hook/dist/useGlobalAuth'

export const sendUserToProductFruits = (user: UserResponseDto): void => {
  if (window.dataLayer) {
    window.dataLayer.push({
      productFruitsUser: {
        username: user.id,
        email: user.email,
        firstname: user.firstName,
        lastname: user.lastName,
        role: user.roles != null ? user.roles.join(', ') : undefined,
        props: {
          country: user.country,
          company: user.companyName,
          isPowerHost: user.isPowerHost
        }
      },
      productFruitsWorkspace: 'biz'
    })
    window.dataLayer.push({ event: 'product-fruits-user-set' })
  }
}
